import EventBus from 'event_bus'

export default class BookmarkLoader {
  constructor ($el) {
    this.onBookmarkRemoved = this.onBookmarkRemoved.bind(this)
    this.onBookmarkAdded = this.onBookmarkAdded.bind(this)
    this.onBookmarkReplay = this.onBookmarkReplay.bind(this)
    this.loadData = this.loadData.bind(this)
    this.$el = $el
    this.url = this.$el.data('bookmarksUrl')
    this.jobs = []
    this.loadData()
    this.addEventListeners()
  }

  addEventListeners () {
    EventBus.on('bookmarks:added', this.onBookmarkAdded)
    EventBus.on('bookmarks:removed', this.onBookmarkRemoved)
    EventBus.on('bookmarks:replay', this.onBookmarkReplay)
  };

  removeEventListeners () {
    EventBus.off('bookmarks:added', this.onBookmarkAdded)
    return EventBus.off('bookmarks:removed', this.onBookmarkRemoved)
  };

  onBookmarkAdded (_event, jobId) {
    var index
    index = this.jobs.indexOf(jobId)
    if (index === -1) {
      this.jobs.push(jobId)
    }
  };

  onBookmarkRemoved (_event, jobId) {
    var index
    index = this.jobs.indexOf(jobId)
    if (index > -1) {
      this.jobs.splice(index, 1)
    }
  };

  onBookmarkReplay (_event, _data) {
    this.jobs.forEach((jobId) => {
      EventBus.trigger('bookmarks:added', jobId)
    })
  }

  loadData () {
    return this.fetchData()
  };

  fetchData () {
    return $.ajax({
      type: 'GET',
      url: this.url
    }).done((function (_this) {
      return function (data) {
        _this.jobs = data
        return _this.triggerBookmarksAdded()
      }
    })(this))
  };

  triggerBookmarksAdded () {
    var jobId, i, len, ref, results
    ref = this.jobs
    results = []
    for (i = 0, len = ref.length; i < len; i++) {
      jobId = ref[i]
      results.push(EventBus.trigger('bookmarks:added', jobId))
    }
    return results
  };
}
